"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// Barcode module — simplified like Modal.js (no check-ready loops)
// - Listens for System.BarcodeManager.Notify.Read (non-encrypted)
// - Can query System.BarcodeManager.GetCurrentScanner (non-encrypted)
// - Service handshake mirrors Modal/Print: respond to System.ServiceNotification
var Barcode = exports["default"] = /*#__PURE__*/function (_Core) {
  function Barcode(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Barcode);
    _this = _callSuper(this, Barcode, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.publicKey = props.publicKey;
    _this.services = props.services || {};
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.myServices = ["sbs"]; // barcode service abbrev
    _this.init();
    return _this;
  }
  (0, _inherits2["default"])(Barcode, _Core);
  return (0, _createClass2["default"])(Barcode, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var data, payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // first inbound message marks ready (same leniency as Modal)
              if (this.ready === false) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Barcode module is ready", "Barcode");
              }

              // ignore echoes from ourselves
              if (!(message.origin === "sdk-" + this.appName)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _t = message.action;
              _context.next = _t === "System.SDK.ServiceNotification.Response" ? 2 : _t === "System.ServiceNotification" ? 4 : _t === "System.BarcodeManager.Notify.Read" ? 7 : 8;
              break;
            case 2:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              try {
                this.services[message.origin] = JSON.parse(message.data);
              } catch (_) {}
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context.abrupt("return");
            case 4:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              data = JSON.parse(message.data);
              _context.next = 6;
              return this.connection.invoke("messaging", {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 6:
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context.abrupt("return");
            case 7:
              // payload example: { barcodeData: "80290UMH8", success: true }
              try {
                payload = typeof message.data === "string" ? JSON.parse(message.data) : message.data || {};
                this.trigger("read", payload);
              } catch (e) {
                _logger["default"].error("Barcode Read", "Invalid payload: " + e.message, "Barcode");
              }
              return _context.abrupt("return");
            case 8:
              return _context.abrupt("continue", 9);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) found = true;
      });
      return found;
    }

    /**
     * Public API — non-encrypted request for current scanner
     * Resolves with ScannerInfo or { success:false, message }
     */
  }, {
    key: "getCurrentScanner",
    value: function getCurrentScanner() {
      var _this3 = this;
      return new Promise(function (resolve) {
        var payload = {
          action: "System.BarcodeManager.GetCurrentScanner",
          uuid: (0, _uuid.v4)(),
          requestUuid: "",
          origin: "sdk-" + _this3.appName,
          data: "{}"
        };

        // one-shot listener (simple like Modal.showModalDialog)
        var _handler = function handler(msg) {
          if (msg.action === "System.BarcodeManager.GetCurrentScanner.Response") {
            try {
              resolve(typeof msg.data === "string" ? JSON.parse(msg.data) : msg.data);
            } catch (_unused) {
              resolve({
                success: false,
                message: "invalid response"
              });
            }
            _this3.connection.off && _this3.connection.off("messaging", _handler);
          }
        };

        // attach before send to avoid race
        _this3.connection.on("messaging", _handler);
        _this3.connection.invoke("messaging", payload);
      });
    }
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Barcode module init, waiting for services", "Barcode");
      var found = this.detectServices();
      if (!found) {
        _logger["default"].warn("Initialization", "No barcode service yet; will await ServiceNotification", "Barcode");
      } else {
        this.ready = true;
        this.trigger("ready", true);
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);